"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Breakpoints = require("pricing-pages-unified-ui/constants/Breakpoints");

var _globalNavHeight = _interopRequireDefault(require("nav-meta/global-nav-height"));

var Positioning = _styledComponents.default.div.withConfig({
  displayName: "GuaranteeBlob__Positioning",
  componentId: "sc-1sh5tee-0"
})(["position:absolute;z-index:-1;top:", ";@media (max-width:", "px){display:none;}"], "-" + _globalNavHeight.default, _Breakpoints.GUARANTEE_SECTION);

var _default = function _default() {
  return _react.default.createElement(Positioning, null, _react.default.createElement("svg", {
    width: "1100px",
    viewBox: "0 0 1372 613",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("path", {
    fill: "#F5F8FA",
    transform: "translate(-68.000000, -37.000000)",
    d: "M214.505639,89.27689 C495.098924,-14.8441387 1134.236,49.2342449 1329.70379,170.419485 C1525.17157,291.604725 1453.47233,483.500647 1172.87905,587.621676 C892.285765,691.742705 532.48833,661.062589 319.055466,528.739439 C105.622602,396.416289 -66.087645,193.397919 214.505639,89.27689 Z",
    id: "bg-blob"
  })));
};

exports.default = _default;
module.exports = exports.default;